import axios from 'axios'

const usuariosURL = './datos/listadoUsuarios'
const updUsuarioURL = './datos/actualizarUsuario'
const insUsuarioURL = './datos/insertarUsuario'

const rolesURL = './datos/listadoRoles'

const vehiculosURL = './datos/listadoVehiculos'
const vehiculosConTasasURL = './datos/listadoVehiculosConTasas'
const updVehiculoURL = './datos/actualizarVehiculo'
const insVehiculoURL = './datos/insertarVehiculo'

const dataCreditoPymeURL = './datos/listadoDataCreditoPyme'

const creditosURL = './datos/listadoCreditos'
const creditosConTasasURL = './datos/listadoCreditosConTasas'
const updCreditoURL = './datos/actualizarTipoCredito'
const insCreditoURL = './datos/insertarTipoCredito'

const modelosURL = './datos/listadoModelos'
const updModeloURL = './datos/actualizarModelo'
const insModeloURL = './datos/insertarModelo'

const plazosURL = './datos/listadoPlazos'
const updPlazoURL = './datos/actualizarPlazo'
const insPlazoURL = './datos/insertarPlazo'

const vehiculosTiposCredModelosURL = './datos/listadoVehiculosTiposCredModelos'
const vehiculosTiposCredModelosConTasasURL = './datos/listadoVehiculosTiposCredModelosConTasas'
const insVehiculoTiposCredModeloURL = './datos/insertarVehiculoTipoCredModelo'
const updVehiculoTiposCredModeloURL = './datos/actualizarVehiculoTipoCredModelo'

const tasasURL = './datos/listadoTasas'
const tasasByParamURL = './datos/listadoTasasByParam'
const tasasDataByParamURL = './datos/listadoTasasDataByParam'
//const tasasDataAdelCuotaByParamURL = './datos/listadoTasasDataAdelCuotaByParam'
const insActTasaURL = './datos/insActTasa'

const consultasURL = './datos/listadoConsultas'

const situacionBCRAURL = './api/deudas'

let token = null
const setToken = (newToken) => {
    token = `Bearer ${newToken}`
}

const isTokenExpired = (token) => {
    if (!token) return true;

    try {
        const payloadBase64 = token.split('.')[1];
        const payload = JSON.parse(atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/')));
        const exp = payload.exp * 1000; // exp está en segundos, convertimos a ms
        return Date.now() > exp;
    } catch (error) {
        return true; // Si no se puede decodificar, asumimos expirado
    }
};

const getConfig = () => {
    return (
        {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            }
        }
    )
}

const listarUsuarios = async (state) => {
    try {
        const data = await axios.get(usuariosURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const actualizarUsuario = async (id, _usuario) => {
    try {
        let config = {
            data: {
                id: id,
                _usuario: _usuario
            }
        }

        const data = await axios.put(updUsuarioURL + `/${id}`, _usuario, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const insertarUsuario = async (_usuario) => {
    try {
        const data = await axios.post(insUsuarioURL, _usuario, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarRoles = async (state) => {
    try {
        const data = await axios.get(rolesURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const listarVehiculos = async (state, all) => {
    try {
        const data = await axios.get(vehiculosURL, getConfig())

        if (all) {
            state(data.data)
        }
        else {
            state(data.data.filter((x) => x.activo))
        }
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const listarVehiculosConTasas = async (state, all) => {
    try {
        const data = await axios.get(vehiculosConTasasURL, getConfig())

        if (all) {
            state(data.data)
        }
        else {
            state(data.data.filter((x) => x.activo))
        }
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const actualizarVehiculo = async (id, _vehiculo) => {
    try {
        let config = {
            data: {
                id: id,
                _vehiculo: _vehiculo
            }
        }

        const data = await axios.put(updVehiculoURL + `/${id}`, _vehiculo, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const insertarVehiculo = async (_vehiculo) => {
    try {
        const data = await axios.post(insVehiculoURL, _vehiculo, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarCreditos = async (state, all) => {
    try {
        const data = await axios.get(creditosURL, getConfig())
        if (all) {
            state(data.data)
        }
        else {
            state(data.data.filter((x) => x.activo))
        }
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}


const listarDataCreditoPyme = async (_vehiculo, _capital, _cuotas, _usuarioID, state) => {
    // 
    try {
        let config = {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            },
            params: {
                _vehiculo: _vehiculo,
                _capital: _capital,
                _cuotas: _cuotas,
                _usuarioID: _usuarioID
            }
        }
        const data = await axios.get(dataCreditoPymeURL, config)

        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarCreditosConTasas = async (state, all) => {
    try {
        const data = await axios.get(creditosConTasasURL, getConfig())

        if (all) {
            state(data.data)
        }
        else {
            state(data.data.filter((x) => x.activo))
        }
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const actualizarCredito = async (id, _credito) => {
    try {
        const data = await axios.put(updCreditoURL + `/${id}`, _credito, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const insertarCredito = async (_credito) => {
    try {
        const data = await axios.post(insCreditoURL, _credito, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarModelos = async (state) => {
    try {
        const data = await axios.get(modelosURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const actualizarModelo = async (id, _modelo) => {
    try {
        const data = await axios.put(updModeloURL + `/${id}`, _modelo, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const insertarModelo = async (_modelo) => {
    try {
        const data = await axios.post(insModeloURL, _modelo, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarPlazos = async (state) => {
    try {
        const data = await axios.get(plazosURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const actualizarPlazo = async (id, _plazo) => {
    try {
        const data = await axios.put(updPlazoURL + `/${id}`, _plazo, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const insertarPlazo = async (_plazo) => {
    try {
        const data = await axios.post(insPlazoURL, _plazo, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarVehiculosTiposCredModelos = async (state) => {
    try {
        const data = await axios.get(vehiculosTiposCredModelosURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const listarVehiculosTiposCredModelosConTasas = async (state) => {
    try {
        const data = await axios.get(vehiculosTiposCredModelosConTasasURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const insertarVehiculoTipoCredModelo = async (_vinculacion) => {
    try {
        const data = await axios.post(insVehiculoTiposCredModeloURL, _vinculacion, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const actualizarVehiculoTipoCredModelo = async (id, _vinculacion) => {
    try {
        const data = await axios.put(updVehiculoTiposCredModeloURL + `/${id}`, _vinculacion, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarConsultas = async (state) => {
    try {
        const data = await axios.get(consultasURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const listarTasas = async (state) => {
    try {
        const data = await axios.get(tasasURL, getConfig())
        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            return window.location.href = '/logout'
        }
    }
}

const listarTasaByParam = async (_tipoCreditoID, _vehiculoID, _modeloID, _capital, _usuarioID, state) => {
    // 
    try {
        let config = {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            },
            params: {
                _tipoCreditoID: _tipoCreditoID,
                _vehiculoID: _vehiculoID,
                _modeloID: _modeloID,
                _capital: _capital,
                _usuarioID: _usuarioID
            }
        }
        const data = await axios.get(tasasByParamURL, config)

        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const listarTasasDataByParam = async (_tipoCreditoID, _vehiculoID, _modeloID, state) => {
    // 
    try {
        let config = {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            },
            params: {
                _tipoCreditoID: _tipoCreditoID,
                _vehiculoID: _vehiculoID,
                _modeloID: _modeloID
            }
        }
        const data = await axios.get(tasasDataByParamURL, config)

        state(data.data)
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

//const listarTasasDataAdelCuotaByParam = async (_vehiculoID, state) => {
//    // 
//    try {
//        let config = {
//            headers: {
//                Authorization: token,
//                'Content-Type': 'application/json'
//            },
//            params: {
//                _vehiculoID: _vehiculoID,
//            }
//        }
//        const data = await axios.get(tasasDataAdelCuotaByParamURL, config)

//        state(data.data)
//    }
//    catch (e) {
//        if (e.response.status === 401) {
//            //return window.location.href = '/logout'
//        }
//    }
//}

const insActTasa = async (_tasa) => {
    try {
        const data = await axios.post(insActTasaURL, _tasa, getConfig())
        return data.data;
    }
    catch (e) {
        if (e.response.status === 401) {
            //return window.location.href = '/logout'
        }
    }
}

const consultarSituacion = async (_cuit) => {
    try {

        //Opción anterior
        //const targetUrl = 'https://api.bcra.gob.ar/centraldedeudores/v1.0/Deudas/' + _cuit;
        //const url = `https://corsproxy.io/?${encodeURIComponent(targetUrl)}`;

        //const url = `https://corsproxy.io/?${targetUrl}`;
        //const response = await axios.get(url);

        let config = {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            },
            params: {
                _cuit: _cuit
            }
        }

        const response = await axios.get(situacionBCRAURL, config)

        return response.data;
    }
    catch (e) {
        console.error("Error consultando BCRA:", e);
        if (e.response) {
            console.log("Status:", e.response.status);
            console.log("Data del error:", e.response.data);  // ← Esto es clave para ver el mensaje real
        }
        throw e;
    }
}


// eslint-disable-next-line
export default {
    listarUsuarios, actualizarUsuario, insertarUsuario,
    listarRoles,
    listarVehiculos, listarVehiculosConTasas, actualizarVehiculo, insertarVehiculo,
    listarDataCreditoPyme, listarCreditos, listarCreditosConTasas, actualizarCredito, insertarCredito,
    listarModelos, actualizarModelo, insertarModelo,
    listarPlazos, actualizarPlazo, insertarPlazo,
    listarVehiculosTiposCredModelos, listarVehiculosTiposCredModelosConTasas, actualizarVehiculoTipoCredModelo, insertarVehiculoTipoCredModelo,
    listarTasas, listarTasaByParam, listarTasasDataByParam, insActTasa,
    listarConsultas, setToken, isTokenExpired,
    consultarSituacion
}